import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';

const appPublicRoutes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forChild(appPublicRoutes),
  ],
  exports: [RouterModule]
})
export class PublicRoutingModule {
}
